import { ReactNode } from 'react';
import { Row, RowDirectionType, RowName, RowOffsetType, RowValue } from './styles';
import StatusHintIcon from '@/images/StatusHintIcon.svg?react';
import { Tooltip, TooltipPropsType } from '@/components/Tooltip/Tooltip';

export type DetailsTowTooltipType = {
  name: string;
  content: ReactNode;
  options?: TooltipPropsType;
};

type DetailsRowType = {
  name: ReactNode;
  children?: ReactNode;
  tooltip?: DetailsTowTooltipType;
  hasHighlight?: boolean;
  hasBorder?: boolean;
  direction?: RowDirectionType;
  offset?: RowOffsetType;
  isHeader?: boolean;
  title?: string;
};

export const DetailsRow = ({
  name,
  children,
  tooltip,
  hasHighlight,
  hasBorder,
  direction,
  offset = 'default',
  isHeader,
  title,
}: DetailsRowType) => {
  const tooltipProps = tooltip ? { 'data-tooltip-id': tooltip.name } : null;
  const tooltipOptions = tooltip ? tooltip.options : {};

  return (
    <Row hasHighlight={hasHighlight} hasBorder={hasBorder} direction={direction} offset={offset} isHeader={isHeader}>
      <RowName isHeader={isHeader}>
        {name}
        {tooltip && (
          <>
            <StatusHintIcon {...tooltipProps} />
            <Tooltip id={tooltip.name} {...tooltipOptions}>
              {tooltip.content || children}
            </Tooltip>
          </>
        )}
      </RowName>
      <RowValue hasBorder={hasBorder} direction={direction} title={title}>
        {children}
      </RowValue>
    </Row>
  );
};
